// extracted by mini-css-extract-plugin
module.exports = {"InnerDiv":"BannerSlider_InnerDiv__2Gh72","BannerItem":"BannerSlider_BannerItem__3Uobl"};